import {
  SET_BIN_LABELS,
  SET_BIN_DIVIDERS,
  SET_CHROMA_ISOLINES,
  SET_REPORT_DATA,
  SET_LIBRARY_DATA,
  SET_LUOX_DATA,
  SET_PASTE_LUOX_DATA,
  SET_LUOX_UNITS,
  DELETE_LIBRARY_ITEM,
  CLEAR_LIBRARY_DATA,
  SET_FULL_REPORT_METADATA,
  DELETE_FULL_REPORT_METADATA,
  SET_GLOBAL_SPINNER,
  SET_GLOBAL_TOAST,
  SET_EXCEL_UPLOAD_ERRORS,
  SET_SHOW_EXCEL_UPLOAD_ERRORS,
} from './types';

export const setReportData = (reportData) => ({
  type: SET_REPORT_DATA,
  payload: { reportData },
});

export const setLibraryData = (libraryData) => ({
  type: SET_LIBRARY_DATA,
  payload: { libraryData },
});

export const setLuoxData = (luoxData) => ({
  type: SET_LUOX_DATA,
  payload: { luoxData },
});

export const setPasteLuoxData = (pasteLuoxData) => ({
  type: SET_PASTE_LUOX_DATA,
  payload: { pasteLuoxData },
});

export const setLuoxUnits = (luoxUnits) => ({
  type: SET_LUOX_UNITS,
  payload: { luoxUnits },
});

export const setExcelUploadErrors = (uploadErrors) => ({
  type: SET_EXCEL_UPLOAD_ERRORS,
  payload: { uploadErrors },
});

export const setShowExcelUploadErrors = (showError) => ({
  type: SET_SHOW_EXCEL_UPLOAD_ERRORS,
  payload: { showError },
});

export const deleteLibraryItem = (item) => ({
  type: DELETE_LIBRARY_ITEM,
  payload: { item },
});

export const clearLibraryData = () => ({
  type: CLEAR_LIBRARY_DATA,
  payload: {},
});

export const setBinLabels = (bin_labels) => ({
  type: SET_BIN_LABELS,
  payload: bin_labels,
});

export const setBinDividers = (bin_dividers) => ({
  type: SET_BIN_DIVIDERS,
  payload: bin_dividers,
});

export const setChromaIsolines = (chroma_isolines) => ({
  type: SET_CHROMA_ISOLINES,
  payload: chroma_isolines,
});

export const setFullReportMetadataItems = (data) => ({
  type: SET_FULL_REPORT_METADATA,
  payload: data,
});

export const deleteFullReportMetadata = (id) => ({
  type: DELETE_FULL_REPORT_METADATA,
  payload: id,
});

export const setGlobalSpinner = (show) => ({
  type: SET_GLOBAL_SPINNER,
  payload: show,
});

export const setGlobalToast = (toast) => ({
  type: SET_GLOBAL_TOAST,
  payload: toast,
});
